import React from 'react';
import './HeroSection.css';

const HeroSection: React.FC = () => {
  return (
    <section id="hero" className="hero">
      <div className="hero__bg">
        <div className="hero__bg-shape hero__bg-shape--1" />
        <div className="hero__bg-shape hero__bg-shape--2" />
        <div className="hero__bg-shape hero__bg-shape--3" />
      </div>

      <div className="hero__container container">
        <div className="hero__content">
          <div className="hero__badge">
            <span className="hero__badge-dot" />
            Trusted by 10,000+ users
          </div>

          <h1 className="hero__title">
            Your Health,
            <br />
            <span className="hero__title-accent">Simplified.</span>
          </h1>

          <p className="hero__subtitle">
            Scan and upload your medical reports, track your health score, and
            get personalized wellness recommendations — all in one platform.
          </p>

          <div className="hero__actions">
            <a href="#download" className="btn btn-primary hero__btn">
              Download App
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
            <a href="#how-it-works" className="btn btn-secondary hero__btn">
              See How It Works
            </a>
          </div>

          <div className="hero__stats">
            {/* Phase 2: Partner Labs stat — lab network hidden for Phase 1 */}
            {/* <div className="hero__stat">
              <span className="hero__stat-number">500+</span>
              <span className="hero__stat-label">Partner Labs</span>
            </div>
            <div className="hero__stat-divider" /> */}
            {/* Phase 2: Tests Completed stat — replaced with reports metric for Phase 1 */}
            {/* <div className="hero__stat">
              <span className="hero__stat-number">50K+</span>
              <span className="hero__stat-label">Tests Completed</span>
            </div>
            <div className="hero__stat-divider" /> */}
            <div className="hero__stat">
              <span className="hero__stat-number">10K+</span>
              <span className="hero__stat-label">Reports Analyzed</span>
            </div>
            <div className="hero__stat-divider" />
            <div className="hero__stat">
              <span className="hero__stat-number">99%</span>
              <span className="hero__stat-label">Scan Accuracy</span>
            </div>
            <div className="hero__stat-divider" />
            <div className="hero__stat">
              <span className="hero__stat-number">4.8</span>
              <span className="hero__stat-label">User Rating</span>
            </div>
          </div>
        </div>

        <div className="hero__visual">
          <div className="hero__phone">
            <div className="hero__phone-screen">
              <div className="hero__phone-header">
                <div className="hero__phone-notch" />
              </div>
              <div className="hero__phone-content">
                <div className="hero__phone-greeting">Good Morning!</div>
                <div className="hero__phone-score">
                  <div className="hero__phone-score-ring">
                    <span>85</span>
                  </div>
                  <div className="hero__phone-score-label">Health Score</div>
                </div>
                <div className="hero__phone-cards">
                  {/* Phase 2: Upcoming Test card — lab scheduling hidden for Phase 1 */}
                  {/* <div className="hero__phone-card">
                    <div className="hero__phone-card-icon hero__phone-card-icon--blue">&#128300;</div>
                    <div>
                      <div className="hero__phone-card-title">Upcoming Test</div>
                      <div className="hero__phone-card-sub">Blood Panel</div>
                    </div>
                  </div> */}
                  <div className="hero__phone-card">
                    <div className="hero__phone-card-icon hero__phone-card-icon--blue">&#128247;</div>
                    <div>
                      <div className="hero__phone-card-title">Latest Scan</div>
                      <div className="hero__phone-card-sub">CBC Report</div>
                    </div>
                  </div>
                  <div className="hero__phone-card">
                    <div className="hero__phone-card-icon hero__phone-card-icon--green">&#128202;</div>
                    <div>
                      <div className="hero__phone-card-title">Latest Report</div>
                      <div className="hero__phone-card-sub">All Normal</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
